<template>
  <div class="animated fadeIn">
    <!-- Cancellations -->
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <b-card class="border-0">
            <div class="card-text">
              <div class="d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2">
                <div class="text-dark mr-3"><i class="el-icon-success headericon"></i></div>
                <div class="h4 font-weight-bold text-dark">Dit Abonnement</div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="showDismissibleAlert">
        <b-col cols="12">
        <b-alert variant="success" dismissible :show="showDismissibleAlert"  >
          <h5>Dit abonnement er hermed opsagt. Vi håber naturligvis at du vil benytte vores service en anden gang. Sidste dag for samarbejdet er {{enddate}}
          </h5>

        </b-alert>
        </b-col>
        <b-col>
          <b-card no-body class="pt-0 pr-2 pb-0 border-0">
            <div class="card-text">
              <div class="h6 pt-2 open-sans pb-0 line-height-golden">
                <div class="card-text">
                  <div class="h6 p-3 open-sans line-height-golden">
                    Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="font-weight-bold">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="font-weight-bold">info@haandvaerker.dk</a>.

                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="!showDismissibleAlert">
        <b-col cols="12">
          <b-card no-body class="pt-0 pr-2 pb-0 border-0">
            <div class="card-text">
              <div class="h6 pt-2 open-sans pb-0 line-height-golden">
                <div class="card-text">
                  <div class="h6 p-4 open-sans line-height-golden">
                    <b-form @submit="onSubmitInformation" >
                      <fieldset>

                       <b-form-row>
                          <b-col sm="12" md="6" lg="6">
                            <div class="py-3"></div>
                            <b-form-group id="desc"
                                          label="Vi er utrolig ked af, at du ønsker at opsige dit abonnement hos os! Det vil være en stor hjælp for os, hvis du vil give en uddybende begrundelse for din opsigelse."
                                          label-for="desc">
                              <b-form-textarea id="textarea2"
                                               placeholder="Beskriv med minimum 25 karakterer..."
                                               v-model="s6"

                                               :rows="6"></b-form-textarea>


                            </b-form-group>
                          </b-col>
                        </b-form-row>


                        <b-form-row>
                          <b-col class="text-center my-4"  sm="12" md="6" lg="6">
                            <div class="py-2"></div>
                            <b-btn size="lg" class="mx-auto rounded font-weight-bold" variant="danger" type="submit">
                              <span>Bekræft opsigelse</span>
                            </b-btn>
                          </b-col>
                        </b-form-row>
                      </fieldset>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'kreditkort',
  components: {
    loading,
    Simplert
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      enddate: '',
      show: false,
      label: 'Loading...',
      overlay: 1,
      haaCredit: false,
      Canexpire: true,
      showimentor: true,
      opsige: false,
      opsigeother: false,
      showDismissibleAlert: false,
      s1: [],
      s2: '',
      s3: '',
      s4: '',
      s5: '',
      s6: '',
      options: [
        { text: 'Jeg har ikke brug for at få flere ordrer hjem lige nu.', value: 1 },
        { text: 'Markedspladsen var for svær at bruge.', value: 2 },
        { text: 'Jeg har ikke fået vist nok opgaver på markedspladsen.', value: 3 },
        { text: 'For mange af mine møder blev aflyst før afholdelse.', value: 4 },
        { text: 'Kunderne var generelt ikke interesserede i mine tilbud.', value: 5 },
        { text: 'For få tilbud blev til ordrer.', value: 6 },
        { text: 'Jeg havde en dårlig oplevelse med en medarbejder.', value: 7 },
        { text: 'Månedsprisen er for høj.', value: 8 },
        { text: 'Andre', value: 9 }
      ],
      options2: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5', value: 5 },
        { text: '6', value: 6 },
        { text: '7', value: 7 },
        { text: '8', value: 8 },
        { text: '9', value: 9 },
        { text: '10', value: 10 }
      ]
    }
  },
  methods: {
    onSubmitInformation (evt) {
      evt.preventDefault()
      if (this.s6.length < 25) {
        let obj = {
          title: 'Hov, du mangler at skrive grunden til din opsigelse.',
          message: '',
          type: 'warning'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'expire_partner_profile', salesPerson: this.salesPerson, levid: this.haaId, s1: this.s1, s2: this.s2, s3: this.s3, s4: this.s4, s5: this.s5, s6: this.s6, opsige: this.opsige, opsigeother: this.opsigeother}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              this.showDismissibleAlert = true
              this.enddate = res.enddate
              let obj = {
                title: 'Gennemført! Sidste dag for samarbejdet er ' + this.enddate,
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.showDismissibleAlert = true
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  },
  created () {
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          if (!res.opsige && !res.opsigeother) {
            this.$router.push('/expire-subscription')
          }
          this.opsige = res.opsige
          this.opsigeother = res.opsigeother
          this.haaCredit = res.haacredit
        },
        response => {
          alert('error')
        }
      )
  }
}
</script>
<style>
  .simplert__content  {
    max-width: 600px;
  }

  .custom-control {
    position: initial;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
    margin-right: 1rem;
  }

  .custom-control-input {
    position: unset;
    z-index: -1;
    opacity: 1;
    margin-right: 14px;
  }

  .radiocancel input[type="radio"] {
    opacity: 0;
  }


</style>



// WEBPACK FOOTER //
// ExpireSubscriptionForm.vue?6e855499